(() => {
  'use strict';

  const blockedTerms = ['email', 'address', 'phone', 'query', 'search', 'payment'];
  const blockedNameFields = new Set(['name', 'first_name', 'last_name', 'full_name', 'customer_name', 'billing_name', 'shipping_name']);
  const toSnakeCase = (value) => value.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);

  const analyticsAllowed = () => {
    if (window.osmodiAnalyticsConsent === true) return true;
    if (document.documentElement.dataset.analyticsConsent === 'granted') return true;
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    return Boolean(privacy && typeof privacy.analyticsProcessingAllowed === 'function' && privacy.analyticsProcessingAllowed());
  };

  const cleanValue = (value) => {
    if (value === 'true') return true;
    if (value === 'false') return false;
    if (/^-?\d+(\.\d+)?$/.test(value)) return Number(value);
    return value.slice(0, 180);
  };

  const paramsFromDataset = (dataset) => Object.entries(dataset).reduce((params, [key, value]) => {
    if (!key.startsWith('osmodi') || key === 'osmodiEvent') return params;
    const parameterName = toSnakeCase(key.replace(/^osmodi/, '').replace(/^./, (letter) => letter.toLowerCase()));
    if (blockedNameFields.has(parameterName) || blockedTerms.some((term) => parameterName.includes(term))) return params;
    if (parameterName && value !== '') params[parameterName] = cleanValue(value);
    return params;
  }, {});

  const track = (eventName, parameters = {}) => {
    if (!analyticsAllowed() || !eventName) return false;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...parameters });
    return true;
  };

  window.osmodiTrack = track;

  const initialize = () => {
    const homepage = document.querySelector('[data-osmodi-homepage]');
    if (homepage) {
      track('view_homepage', paramsFromDataset(homepage.dataset));
    }

    const itemData = document.querySelector('script[data-osmodi-item]');
    if (itemData) {
      try {
        track('view_item', JSON.parse(itemData.textContent));
      } catch (error) {
        document.dispatchEvent(new CustomEvent('osmodi:analytics-error', { detail: { category: 'invalid-item-data' } }));
      }
    }

    document.addEventListener('click', (event) => {
      const target = event.target.closest('[data-osmodi-event]');
      if (!target) return;
      track(target.dataset.osmodiEvent, paramsFromDataset(target.dataset));
    });

    const impressionTargets = document.querySelectorAll('[data-osmodi-impression]');
    if (!impressionTargets.length || !('IntersectionObserver' in window)) return;

    const seen = new WeakSet();
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting || entry.intersectionRatio < 0.5 || seen.has(entry.target)) return;
        seen.add(entry.target);
        track(entry.target.dataset.osmodiImpression, paramsFromDataset(entry.target.dataset));
        observer.unobserve(entry.target);
      });
    }, { threshold: [0.5] });

    impressionTargets.forEach((target) => observer.observe(target));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
